export class Constantes {

  //constantes genéricas
  public static VALOR_SI: string = "S";
  public static VALOR_NO: string = "N";
  public static NOMBRE_VALOR_SI: string = "Sí";
  public static NOMBRE_VALOR_NO: string = "No";
  public static GRID_PAGE_SIZE: number = 10;
  public static GRID_PAGE_SIZE_OPTIONS: Array<number> = [10, 20, 30];

  public get VALOR_SI() {
    return Constantes.VALOR_SI;
  }

  public get VALOR_NO() {
    return Constantes.VALOR_NO;
  }

  public get NOMBRE_VALOR_SI() {
    return Constantes.NOMBRE_VALOR_SI;
  }

  public get NOMBRE_VALOR_NO() {
    return Constantes.NOMBRE_VALOR_NO;
  }

  //constantes de tipos de usuario
  public static TIPO_USUARIO_GNR: string = "GNR";
  public static TIPO_USUARIO_GNV: string = "GNV";
  public static TIPO_USUARIO_SIFISE: string = "SIFISE";

  //constantes de parámetros de URL
  public static URL_PARAM_OPCION: string = "pagina";

  //constantes de páginas de GNR
  public static PAGINA_GNR = {
    "buscador-empresas-instaladoras": '/gnr/buscador-empresas-instaladoras',
    "buscador-promotores-venta": '/gnr/buscador-promotores-venta',
    "buscador-empresas-inhabilitadas": '/gnr/buscador-empresas-inhabilitadas',
    "buscador-instaladores-inhabilitados": '/gnr/buscador-instaladores-inhabilitados',
    "buscador-penalidades-convenios": '/gnr/buscador-penalidades-convenios',
  }

  //constantes de expresiones regulares
  public static REGEX_NUMERO_ENTERO_POSITIVO: RegExp = new RegExp('^[0-9]*$');
  public static REGEX_EMAIL_VALIDO: RegExp = new RegExp(/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/);

}
